import Modulo6 from "../pages/modulo6/Modulo6";
import Modulo6U1A1 from "../pages/modulo6/unidad1/Actividad1";
import Modulo6U1A2 from "../pages/modulo6/unidad1/Actividad2";
import Modulo6U1A3 from "../pages/modulo6/unidad1/Actividad3";
import Modulo6U1A4 from "../pages/modulo6/unidad1/Actividad4";
import Modulo6U1A5 from "../pages/modulo6/unidad1/Actividad5";
import Modulo6U1A6 from "../pages/modulo6/unidad1/Actividad6";
import Modulo6U1A7 from "../pages/modulo6/unidad1/Actividad7";
import Modulo6U1A8 from "../pages/modulo6/unidad1/Actividad8";
import Modulo6U1A9 from "../pages/modulo6/unidad1/Actividad9";

export const modulo6 = {
  title: "¿Qué símbolos nos representan como país?",
  grade: { name: "Nivel 2", url: "/nivel-2" },
  module: "Módulo 6",
  year: 'Segundo grado',
  component: <Modulo6 />,
  conclusion: "",
  tags: [
    { name: "símbolos patrios", url: "simbolos-patrios" },
    { name: "identidad", url: "identidad" },
    { name: "nación", url: "nacion" },
  ],
  skills: [
    { name: "Construye su identidad", url: "/construye-su-identidad" },
    {
      name: "Construye interpretaciones históricas",
      url: "/construye-interpretaciones-historicas",
    },
  ],
  url: "que-simbolos-nos-representan-como-pais",
  color: "blue",
  content: [
    {
      name: "Unidad 1",
      path: "unidad-1",
      activities: [
        {
          name: "Actividad 1",
          path: "actividad-1",
          component: <Modulo6U1A1 />,
        },
        {
          name: "Actividad 2",
          path: "actividad-2",
          component: <Modulo6U1A2 />,
        },
        {
          name: "Actividad 3",
          path: "actividad-3",
          component: <Modulo6U1A3 />,
        },
        {
          name: "Actividad 4",
          path: "actividad-4",
          component: <Modulo6U1A4 />,
        },
        {
          name: "Actividad 5",
          path: "actividad-5",
          component: <Modulo6U1A5 />,
        },
        {
          name: "Actividad 6",
          path: "actividad-6",
          component: <Modulo6U1A6 />,
        },
        {
          name: "Actividad 7",
          path: "actividad-7",
          component: <Modulo6U1A7 />,
        },
        {
          name: "Actividad 8",
          path: "actividad-8",
          component: <Modulo6U1A8 />,
        },
        {
          name: "Actividad 9",
          path: "actividad-9",
          component: <Modulo6U1A9 />,
        },
      ],
    },
  ],
};
